import CIMSFormItem from 'components/CIMSFormItem'
import { CIMSModal } from 'components/CIMSModal'
import RecipientSelect from 'components/CIMSSelect/common/customWorkflows/RecipientSelect'
import { useRecipientSelectContext } from 'components/CIMSSelect/common/customWorkflows/RecipientSelect/RecipientSelectContext'
import type { RecipientValue } from 'components/CIMSSelect/common/customWorkflows/RecipientSelect/types'
import type { LabeledValueType } from 'components/CIMSSelect/types'

type AddRecipientsFormValues = {
  recipients: LabeledValueType[]
}

type AddRecipientsModalProps = {
  loading: boolean
  onAdd: (recipients: RecipientValue[]) => Promise<void>
  onClose: () => void
  visible: boolean
}

function AddRecipientsModal({
  loading,
  onAdd,
  onClose,
  visible,
}: AddRecipientsModalProps) {
  const { fromLabeledValues } = useRecipientSelectContext()

  return (
    <CIMSModal<AddRecipientsFormValues>
      initialFormValues={{ recipients: [] }}
      loading={loading}
      onCancel={onClose}
      onOk={async ({ recipients }) => {
        await onAdd(fromLabeledValues(recipients))
      }}
      title="Add Recipients"
      visible={visible}
    >
      <CIMSFormItem
        label="Recipients"
        name="recipients"
        requiredMessage="Please select at least one recipient"
      >
        <RecipientSelect />
      </CIMSFormItem>
    </CIMSModal>
  )
}

export default AddRecipientsModal
